// Normalise EventSource & WebSocket to VITE_API_BASE origin (when set).
const API_BASE = (import.meta as any).env?.VITE_API_BASE || "";

function rewriteUrl(u: string) {
  if (!API_BASE) return u;
  try {
    const url = new URL(u, typeof window !== "undefined" ? window.location.origin : "http://localhost");
    const base = new URL(API_BASE.replace(/\/+$/,"/"));
    url.protocol = base.protocol;
    url.host = base.host;
    return url.toString();
  } catch { return u; }
}

try {
  const OrigES = window.EventSource;
  (window as any).EventSource = function(input: string, init?: EventSourceInit) {
    return new OrigES(rewriteUrl(input), init);
  } as any;
  (window as any).EventSource.prototype = OrigES.prototype;
} catch {}

try {
  const OrigWS = window.WebSocket;
  (window as any).WebSocket = function(input: string, protocols?: string | string[]) {
    let u = input;
    if (API_BASE) {
      const httpified = rewriteUrl(input);
      u = httpified.replace(/^http:/, "ws:").replace(/^https:/, "wss:");
    }
    return new OrigWS(u, protocols as any);
  } as any;
  (window as any).WebSocket.prototype = OrigWS.prototype;
} catch {}
